import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { HistoryService } from '../../services/history.service';
import { Observable } from 'rxjs';
import * as moment from "moment-timezone";

@Component({
  selector: 'app-vtuber-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class VTuberHistoryComponent implements OnInit {
  sum$: Observable<any>;
  futureMonth: string;

  constructor(
    public auth: AuthService,
    private hs: HistoryService
  ) {}

  ngOnInit() {
    const source = this.hs.getHistories()
    this.sum$ = this.hs.getCurrentMonthBalance(source)

    this.futureMonth = moment().tz('Asia/Tokyo').add(1, "M").format("Y年MM月末*")
  }

}
